import { t } from 'i18next';
import { SendOutlined } from '@ant-design/icons';
import { Button, Flex, Form, Input, Modal, Space, Typography } from 'antd';
import { useState } from 'react';
import { radius } from '@libertify/ui';

export const SendTranscript = ({
  requestTranscript,
}: {
  requestTranscript: (email: string) => void;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleSubmit = (values: { email: string }) => {
    requestTranscript(values.email);
    setIsModalOpen(false);
  };
  return (
    <>
      <Modal
        styles={{
          content: { borderRadius: radius.box },
          body: { paddingTop: 40, paddingBottom: 30 },
        }}
        footer={null}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <Flex vertical gap={30} align="center">
          <Typography.Text type="secondary">
            {t('emailSummaryNote')}
          </Typography.Text>
          <Form onFinish={handleSubmit}>
            <Space.Compact>
              <Form.Item name="email" style={{ width: 260 }}>
                <Input
                  size="large"
                  required
                  placeholder={t("emailAddress")}
                  type="email"
                  style={{
                    borderTopLeftRadius: radius.pill,
                    borderBottomLeftRadius: radius.pill,
                    borderRight: 0,
                  }}
                />
              </Form.Item>
              <Button
                size="large"
                type="primary"
                icon={<SendOutlined />}
                htmlType="submit"
                style={{
                  borderTopRightRadius: radius.pill,
                  borderBottomRightRadius: radius.pill,
                  boxShadow: 'none',
                  width: 50,
                }}
              />
            </Space.Compact>
          </Form>
        </Flex>
      </Modal>
      <Button
        type="primary"
        shape="round"
        size="small"
        style={{ fontSize: 12, boxShadow: 'none' }}
        onClick={() => showModal()}
        icon={
          <svg
            height={10}
            width={10}
            data-slot="icon"
            fill="none"
            strokeWidth="1.5"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
            ></path>
          </svg>
        }
      >
        {t('getSummary')}
      </Button>
    </>
  );
};





